import type { FaireProductEntity } from "../../entity_types/product";

export const p_bfkzjg7a8s: FaireProductEntity = {
  token: "p_bfkzjg7a8s",
  type: "product",
  name: "Soccer Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/dc808b5f73b31fe6bb623ca68f6311e75ea21febbc75aa0c3b0ab12f82ea0b93.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bfbe02cb25efc682a9efcef05b748d7bf80cbbeed0ef3e4ce49547d8ae9639a0.jpeg",
    "https://cdn.faire.com/fastly/8f67172b9034a83a3ce190f78121a801aaa2a2fe9dfc5364366e68643ca5ffd3.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:19.968Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
